<template>
  <div class="flex flex-row flex-wrap">
    <Field
      name="establishmentId"
      v-slot="{ field, errors, handleChange }"
      v-if="isAuthorityEstablishment && pageType == 'mainPage'"
    >
      <SimpleDropdown
        :field="field"
        :errors="errors"
        :label="$t('freeZone')"
        :options="countries"
        :is-required="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-selection="(item) => handleChange(+item.id)"
        :disabled="disabledFiled"
      ></SimpleDropdown>
    </Field>

    <Field name="unifiedNumber" v-slot="{ field, errors }">
      <SimpleTextInput
        :field="field"
        :errors="errors"
        :label="$t('unifiedNumber')"
        :maxLength="10"
        direction="flex-col"
        :isRequired="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        :isDisabled="!!props.values.IdentityNumber"
        mask="numberOnly"
      />
    </Field>

    <Field name="IdentityNumber" v-slot="{ field, errors }">
      <SimpleTextInput
        :field="field"
        :errors="errors"
        :label="$t('emiratesID')"
        :maxLength="10"
        direction="flex-col"
        :isRequired="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        :isDisabled="!!props.values.unifiedNumber"
        mask="numberOnly"
      />
    </Field>
    <Field
      name="expiryFrom"
      v-slot="{ field, errors, handleChange }"
      v-if="pageType != 'canceledEscapeReportPage'"
    >
      <SimpleDatepicker
        :field="field"
        :errors="errors"
        :label="$t('expirystartDate')"
        :max-date="maxDateRef"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-change="(date) => handleChange(date)"
        :disabled="disabledFiled"
        :serverDateFormat="'yyyy/MM/dd'"
      >
      </SimpleDatepicker>
    </Field>

    <Field
      name="expiryTo"
      v-slot="{ field, errors, handleChange }"
      v-if="pageType != 'canceledEscapeReportPage'"
    >
      <SimpleDatepicker
        :field="field"
        :errors="errors"
        :label="$t('expiryendDate')"
        :max-date="maxDateRef"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-change="(date) => handleChange(date)"
        :disabled="disabledFiled"
        :serverDateFormat="'yyyy/MM/dd'"
      >
      </SimpleDatepicker>
    </Field>

    <Field
      name="cancelDate"
      v-slot="{ field, errors, handleChange }"
      v-if="pageType == 'cancelPage'"
    >
      <SimpleDatepicker
        :field="field"
        :errors="errors"
        :label="$t('cancelDate')"
        :max-date="maxDateRef"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-change="(date) => handleChange(date)"
        :disabled="disabledFiled"
        :serverDateFormat="'yyyy/MM/dd'"
      >
      </SimpleDatepicker>
    </Field>

    <Field name="employeeName" v-slot="{ field, errors }">
      <SimpleTextInput
        :field="field"
        :errors="errors"
        :label="$t('sponsorName')"
        :maxLength="10"
        direction="flex-col"
        class="lg:w-1/2 flex-col px-2 w-full"
        :is-required="false"
        :is-disabled="disabledFiled"
      />
    </Field>
    <Field name="nationalityId" v-slot="{ field, errors, handleChange }">
      <SimpleDropdown
        :field="field"
        :errors="errors"
        :label="$t('nationality')"
        :options="countries"
        :is-required="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-selection="(item) => handleChange(+item.id)"
        :disabled="disabledFiled"
      ></SimpleDropdown>
    </Field>
    <Field
      name="selectedModule"
      v-slot="{ field, errors, handleChange }"
      v-if="
        showModules &&
        [
          'mainPage',
          'oleSponsoredPage',
          'cancelPage',
          'escapeAvailablePage',
          'escapeFilesPage'
        ].includes(pageType)
      "
    >
      <SimpleDropdown
        :field="field"
        :errors="errors"
        :label="$t('moduleName')"
        :options="modules"
        :is-required="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-selection="(item) => handleChange(+item.id)"
      ></SimpleDropdown>
    </Field>
    <Field
      name="serviceStatusId"
      v-slot="{ field, errors, handleChange }"
      v-if="showModules && ['mainPage', 'escapeAvailablePage'].includes(pageType)"
    >
      <SimpleDropdown
        :field="field"
        :errors="errors"
        :label="$t('fileValiditymenu')"
        :options="serviceStatusList"
        :is-required="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-selection="(item) => handleChange(+item.id)"
        :disabled="!props.values.selectedModule"
      ></SimpleDropdown>
    </Field>

    <Field name="workPermitNumber" v-slot="{ field, errors }" v-if="pageType == 'mainPage'">
      <SimpleTextInput
        :field="field"
        :errors="errors"
        :label="$t('workPermitNo')"
        direction="flex-col"
        class="lg:w-1/2 flex-col px-2 w-full"
        :is-required="false"
        :is-disabled="disabledFiled"
      />
    </Field>

    <Field
      :value="true"
      :unchecked-value="false"
      v-slot="{ field }"
      name="isViolatorsFlag"
      type="checkbox"
      class="w-full"
      v-if="
        showModules &&
        escapeReport != 1 &&
        ['mainPage', 'escapeAvailablePage', 'canceledEscapeReportPage'].includes(pageType)
      "
    >
      <label class="flex flex-row items-center lg:w-1/2 px-2 w-full gap-2 mt-2">
        <input class="accent-primary" type="checkbox" name="isViolatorsFlag" v-bind="field" />
        {{ $t('Violators') }}
      </label>
    </Field>

    <Field
      :value="true"
      :unchecked-value="false"
      v-slot="{ field }"
      name="isPatientAccompaniedVisaFlag"
      type="checkbox"
      class="w-full"
      v-if="['mainPage', 'escapeAvailablePage'].includes(pageType)"
    >
      <label class="flex flex-row items-center lg:w-1/2 px-2 w-full gap-2 mt-2">
        <input
          class="accent-primary"
          :class="[!!disableActiveLeavePermit && 'cursor-not-allowed']"
          type="checkbox"
          name="isPatientAccompaniedVisaFlag"
          v-bind="field"
          :disabled="!!disableActiveLeavePermit"
        />
        {{ $t('treatmentVisasSponsored') }}
      </label>
    </Field>
  </div>
</template>
<script setup>
import { defineProps, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { Field } from 'vee-validate'
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import SimpleDatepicker from '@/components/SimpleForm/Datepicker.vue'
import { DateTime } from 'luxon'
import lookups from '@/assets/json/clientLookups.json'

import { useAuthStore } from '@/stores/auth'

const route = useRoute()
const authStore = useAuthStore()

const maxDateRef = ref()
maxDateRef.value = DateTime.now().toFormat('dd/MM/yyyy')

const props = defineProps({
  values: Object,
  countries: Array,
  modules: Array,
  serviceStatus: Array,
  pageType: {
    type: String,
    default: 'mainPage'
  }
})

const isAuthorityEstablishment = computed(() => {
  return authStore.user.isAuthorityEstablishment
})

const serviceStatusList = computed(() => {
  const { residencyServiceStatus, visaServiceStatus, module } = lookups
  const residencyList = [
    residencyServiceStatus.residencyActive,
    residencyServiceStatus.residencyNearlyExpired,
    residencyServiceStatus.residencyExpired
  ]
  const visaList = [
    visaServiceStatus.visaActive,
    visaServiceStatus.visaNearlyExpired,
    visaServiceStatus.visaExpired,
    visaServiceStatus.visaUsed
  ]
  const isVisa = props.values.selectedModule == module.visa
  const isResidency = props.values.selectedModule == module.residency

  return props.serviceStatus.filter((i) => {
    if ((isResidency && residencyList.includes(i.id)) || (isVisa && visaList.includes(i.id))) {
      return true
    }
  })
})

const showModules = computed(() => {
  if (!route.params?.serviceId) return true
  return false
})

const escapeReport = computed(() => {
  return route.query?.escapeReport ? 1 : 0
})

const disableActiveLeavePermit = computed(() => {
  return route.query?.disableActiveLeavePermit == 1
})

const disabledFiled = computed(() => {
  return !!props.values.IdentityNumber || !!props.values.unifiedNumber
})
</script>
<style scoped lang="scss"></style>
